export default __webpack_public_path__ + "static/media/node.25b3b685.png";